import _ from 'lodash'
import eventBus from '../utils/eventBus'
import router from '../router'

function scrollMemory (Vue) {
    Vue.directive('scrollMemory', {
        bind (el) {
            let scrollStatus = true
            const currentRoute = router.stack.last()
            el.dataset.routePath = currentRoute.path
            el._scroll_callback = _.debounce(() => {
                const newRoute = router.stack.last()
                if (newRoute.meta.update) {
                    newRoute.meta.update = false
                    currentRoute.meta.scrollY = 0
                    document.documentElement.scrollTop = 0
                } else {
                    if (newRoute.fullPath === currentRoute.fullPath) {
                        if (scrollStatus) {
                            currentRoute.meta.scrollY = document.documentElement.scrollTop
                        } else {
                            scrollStatus = true
                        }
                    } else {
                        scrollStatus = false
                    }
                }
            }, 100)
            window.addEventListener('scroll', el._scroll_callback)
            eventBus.$on(`active:${el.dataset.routePath}`, () => {
                Vue.nextTick(() => {
                    // el.scrollTop = currentRoute.meta.scrollY
                    setTimeout(() => {
                        document.documentElement.scrollTop = currentRoute.meta.scrollY
                    }, 250)
                })
            })
        },
        unbind (el) {
            window.removeEventListener('scroll', el._scroll_callback)
            el._scroll_callback = null
            eventBus.$off(`active:${el.dataset.routePath}`)
        }
    })
}

function autoFocus (V) {
    V.directive('focus', {
        inserted: el => {
            el.focus()
        }
    })
}

/**
 * 注册指令
 * @param Vue Vue
 */
function registDirectives (Vue) {
    scrollMemory(Vue)
    autoFocus(Vue)
}

export default registDirectives
